import { Either, EitherType } from "./either";
import { Functor } from "./functor";

export {
  Either,
  EitherType,
  Functor,
};
